import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useRef, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/checkbox.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import { inputLabelValidator } from '../../prop-types-validators/input-label-validator.js';
import '../_atoms/inline-label/inline-label.js';
import { InputField } from '../_atoms/input-field/input-field.js';
import '../_atoms/nav-elem/nav-elem.js';
import '../_atoms/sr-only/sr-only.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('checkbox', styles);
var Checkbox = function (_a) {
  var id = _a.id,
    extraClasses = _a.extraClasses,
    label = _a.label,
    value = _a.value,
    disabled = _a.disabled,
    valid = _a.valid,
    info = _a.info,
    infoError = _a.infoError,
    small = _a.small,
    _b = _a.indeterminate,
    indeterminate = _b === void 0 ? false : _b,
    ariaDescribedByProp = _a["aria-describedby"],
    rest = __rest(_a, ["id", "extraClasses", "label", "value", "disabled", "valid", "info", "infoError", "small", "indeterminate", 'aria-describedby']);
  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, []);
  var className = bem.b({
    disabled: disabled,
    error: valid === false,
    sm: small,
    indeterminate: indeterminate
  }, extraClasses);
  return /*#__PURE__*/React__default__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default__default.createElement(InputField, __assign({
    ref: inputRef,
    id: id,
    type: "checkbox",
    value: value,
    disabled: disabled,
    className: bem.e('input'),
    valid: valid,
    "aria-errormessage": "infoError-".concat(id),
    "aria-describedby": PropsUtils.handleAriaDescribedBy(info ? "info-".concat(id) : undefined, ariaDescribedByProp)
  }, rest)), /*#__PURE__*/React__default__default.createElement("label", {
    htmlFor: id,
    className: bem.e('label')
  }, label), /*#__PURE__*/React__default__default.createElement(InputInfo, {
    error: true,
    id: id,
    className: bem.e('info')
  }, valid === false ? infoError : ''), info && /*#__PURE__*/React__default__default.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info));
};
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  extraClasses: '',
  disabled: undefined,
  valid: undefined,
  info: undefined,
  infoError: undefined,
  small: false,
  indeterminate: false,
  label: undefined
};
Checkbox.propTypes = {
  extraClasses: PropTypes__default.string,
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  label: inputLabelValidator('Checkbox'),
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  disabled: PropTypes__default.bool,
  valid: PropTypes__default.bool,
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  small: PropTypes__default.bool,
  indeterminate: PropTypes__default.bool
};
var Checkbox$1 = Injecss(Checkbox, styles);

export { Checkbox, Checkbox$1 as default };
